import {
  Component,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  NgZone,
} from '@angular/core';
import { AfterContentInit, OnDestroy } from '@angular/core';
import { Observable, BehaviorSubject, of, forkJoin, EMPTY, Subject } from 'rxjs';

import { Store } from '@ngrx/store';
import { AppState } from '../store/AppState';
import { TaskDTO } from '../api/plyca-dtos';
import * as lodash from 'lodash';
import {
  DefaultDashboards,
  DashBoard,
  DashboardColumn,
  WidgetDefinition,
  AvailableWidgets,
} from '../api/Dashboard-dto';

import { columnDragComponent } from './columnDrag.component';
import { widgetComponent } from './widget.component';
import { favouritesComponent } from './favourites.component';
import { chartComponent } from './chart.component';
import { auditUserComponent } from '../auditUser/audit.user.component';
import { tableComponent } from './table.component';
import { taskCountComponent } from './taskCount.component';

import { UserService } from '../user.service';

import { UserPrefs, MainViewPrefs, SessionInfo } from '../api/UserPrefs-dto';
import { SET_USERPREFS } from '../store/userPrefs';
import { WelcomeNotesService } from '../components/common/welcomeNotes/welcomeNotes.component';
import { UIService } from '../ui.service';
import { taskProcurementCommitteeComponent } from './taskProcurementCommittee.component';
import { HelpService, HelpType } from '../components/common/help/help.service';
import { SelectItem } from 'primeng-lts/api';
import { PlycaDataService } from '../../services/plyca.service';
import { sessionCountComponent } from './sessionCount.component';
import { sysTimeComponent } from './sysTime.component';
import { catchError, map, finalize } from 'rxjs/operators';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { WaitLoadingService } from '../components/common/waitLoading/wait-loading.service';
import { ChangeDetectorRef } from '@angular/core';
import { UserPrefsService } from '../store/user-prefs.service';
import { TranslateService } from '@ngx-translate/core';
import { FormAction, FormConfig } from '../components/forms/form.objects';

@Component({
  selector: 'mainView',
  templateUrl: 'main-view.template.html',
})
export class mainViewComponent
  extends BaseComponent
  implements AfterContentInit, OnDestroy {
  @ViewChild('parent', { read: ViewContainerRef, static: true })
  parent: ViewContainerRef;

  sessionInfo: SessionInfo;

  signTasksCountN: number;

  cols = 0;
  userFullName: string;
  loaded = false;

  // INFORMACION DE LA PANTALLA ALMACENADA EN SESION
  userPrefs: UserPrefs;

  dashBoards: Array<DashBoard> = [];
  dashBoardsOptions: Array<SelectItem> = [];

  // seleccionado en el combo
  activeDashBoard: DashBoard;

  availableWidgets: Array<WidgetDefinition> = [];

  private editMode: BehaviorSubject<boolean>;
  public editModeObservable: Observable<boolean>;

  // para recargar los widget ante cambios en los filtros
  reloadSubject: Subject<boolean>;

  public lastLogin: Date;

  filters: any = {};
  public formConfig: FormConfig;

  constructor(
    private store: Store<AppState>,
    private componentFactoryResolver: ComponentFactoryResolver,
    private userService: UserService,
    private uiService: UIService,
    public helpService: HelpService,
    private welcomeNotesService: WelcomeNotesService,
    protected plycaService: PlycaDataService,
    protected waitService: WaitLoadingService,
    private zone: NgZone,
    private changeDetectorRef: ChangeDetectorRef,
    private userPrefsService: UserPrefsService,
    private translateService: TranslateService
  ) {
    super();
    this.editMode = new BehaviorSubject<any>({});
    this.editModeObservable = this.editMode.asObservable();

    this.reloadSubject = new Subject<any>();

    this.waitService.cancelWaiting();
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.HELP_INIT));

    // STORE 'pendingTasks'
    this.subscribe(store.select('pendingTasks'), (data) => {
      this.signTasksCountN = data.filter((x: TaskDTO) => {
        if (x && x.plycaTaskId) {
          return x.plycaTaskId === 'CRTL_EXPTE';
        } else {
          return false;
        }
      }).length;
    });


    // STORE 'user'
    this.subscribe(this.store.select('user'), (sesinfo: SessionInfo) => {
      this.sessionInfo = sesinfo;

      this.subscribe(this.userPrefsService.getUserPrefs(), (prefs: UserPrefs) => {
        this.userPrefs = prefs;


        if (!this.userPrefs.mainViewPrefs) {
          this.userPrefs.mainViewPrefs = new MainViewPrefs();
        }

        // DIFERENCIAMOS EL ACCESO EN MODO MESA DEL ESTANDAR
        if (!this.userService.getModoAcceso()) {
          // this.userPrefs.mainViewPrefs.dashboards = DefaultDashboards.getDefaultDashboards().slice();
          this.subscribe(
            this.getAvailableWidgets(),
            (_availableWidgets: Array<WidgetDefinition>) => {
              this.availableWidgets = _availableWidgets;
              this.subscribe(
                this.getDashBoardDefs(),
                (ret: Array<DashBoard>) => {
                  if (ret) {
                    this.userPrefs.mainViewPrefs.dashboards = ret.filter(
                      (db) => {
                        // si el dashboard no tiene definidos perfiles ok
                        if (!db.profiles) {
                          // console.log('DASHBOARD SIN PERFILES ', db.id);
                          return true;
                        } else {
                          // console.log('COMPROBANDO PERFILES DE DASHBOARD ', db.id, ' : ', db.profiles, ' -> ',
                          // this.userService.hasRoles(db.profiles));
                          return this.userService.hasRoles(db.profiles);
                        }
                      }
                    ).filter(
                      (db) => {
                        // si el dashboard no tiene definidos perfiles ok
                        if (!db.modules) {
                          // console.log('DASHBOARD SIN PERFILES ', db.id);
                          return true;
                        } else {
                          // console.log('COMPROBANDO PERFILES DE DASHBOARD ', db.id, ' : ', db.profiles, ' -> ',
                          // this.userService.hasRoles(db.profiles));
                          return this.userService.hasModulesAccess(db.modules);
                        }
                      }
                    );
                  }
                  this.initDashBoards();
                }
              );
            }
          );
        } else {
          this.userPrefs.mainViewPrefs.dashboards =
            DefaultDashboards.getProcurementCommitteeDashboards().slice();
        }

        // if (
        //   !this.userPrefs.mainViewPrefs.dashboards ||
        //   this.userPrefs.mainViewPrefs.dashboards.length == 0
        // ) {
        //   this.userPrefs.mainViewPrefs.dashboards = DefaultDashboards.getDefaultDashboards().slice();
        // }
      });
    });
  }

  ngAfterContentInit(): void {
    this.userFullName = this.userService.getUserFullName();
    setTimeout(() => {
      this.welcomeNotesService.viewNotes();
    }, 300);
    this.subscribe(this.store.select('user'), (sesinfo: SessionInfo) => {
      if (sesinfo && sesinfo.user) {
        this.lastLogin = sesinfo.user.lastEntryDate;
        if (!this.lastLogin) {
          this.lastLogin = new Date();
        }
      }
    });
  }

  ngOnDestroy(): void {
    let thisUserPrefs = this.userPrefs;
    this.store.dispatch(SET_USERPREFS({ userPrefs: thisUserPrefs }));

    // marcar complete para obligar a unsubscribe de observables
    this.editMode.complete();
    this.parent = undefined;
    this.zone = null;
    super.ngOnDestroy();
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  // INICIALIZACION DEL DASHBOARD
  initDashBoards(): void {
    console.log('inicializando dashboards');
    this.dashBoards = this.userPrefs.mainViewPrefs.dashboards;
    this.dashBoardsOptions = this.dashBoards.map((db) => {
      return {
        'label': db.descriptionKey ? this.translateService.instant(db.descriptionKey) : db.id,
        value: db,
      };
    });
    let dbActivo: DashBoard = this.dashBoards.find(
      (db: DashBoard) => db.id == this.userPrefs.mainViewPrefs.selectedDashboardId
    );
    if (dbActivo) {
      this.loadComponents(dbActivo);
    } else {
      this.loadComponents(this.dashBoards[0]);
    }
  }

  changeEditMode(e: any) {
    this.editMode.next(e.checked);
  }

  /*
  <p-dropdown

  [options]="dashBoardsOptions"
  [ngModel]="activeDashBoard"
  (onChange)="loadComponents($event.value)"
  dataKey="id">

  </p-dropdown>
  */


  loadComponents(db: DashBoard): void {
    if (db.filters) {
      this.createFormConfig(db);
    } else {
      this.formConfig = undefined;
    }
    this.zone.runOutsideAngular(() => {
      //        if (this.cols > 0)return;
      this.parent.clear();
      this.activeDashBoard = db;
      this.userPrefs.mainViewPrefs.selectedDashboardId = db.id;
      this.cols = this.activeDashBoard.columns.length;
      // soluciona temporal hasta que se modifique el cálculo del número de columnas
      console.log('COLUMNAS DEFINIDAS EN EL DASHBOARD', this.cols);
      this.activeDashBoard.columns.forEach((col: DashboardColumn) => {
        let factory =
          this.componentFactoryResolver.resolveComponentFactory(
            columnDragComponent
          );
        let columnInstance = this.parent.createComponent(factory).instance;
        columnInstance.bagName = 'bag' + col.columnNumber;
        columnInstance.mainViewComponent = this;
        columnInstance.columnIndex = col.columnNumber;

        // para el layout
        let columnsLayout = {};
        columnsLayout['bag1'] = ' d-flex flex-row flex-fill';
        columnsLayout['bag2'] = ' d-flex flex-row flex-fill';
        columnsLayout['bag3'] = ' d-flex flex-row flex-fill';
        // columnsLayout['bag4'] = 'col-12';
        columnInstance.class = columnsLayout['bag' + col.columnNumber];
        console.log('CREANDO COLUMNINSTANCE')
        columnInstance.reloadSubject = this.reloadSubject;
        col.components.forEach((widgetName: string) => {
          let widget: WidgetDefinition = this.getWidgetById(widgetName);
          if (widget) {
            let params = {};

            if (widget.titleKey) {
              params['titleKey'] = widget.titleKey.messageKey;
            }
            if (widget.descriptionKey) {
              params['descriptionKey'] = widget.descriptionKey.messageKey;
            }
            params['title'] = widget.title;
            params['description'] = widget.description;
            params['attributeId'] = widget.attributeId;
            params['attributeParams'] = widget.attributeParams;
            params['id'] = widget.id;
            params['filters'] = this.filters;
            // copiamos la configuracion del widget al componente creado
            if (widget['opts']) {
              for (let key in widget['opts']) {
                if (key) {
                  params[key] = widget['opts'][key];
                }
              }
            }
            columnInstance.insertComponent(
              this.getComponentByName(widget.type),
              params
            );
          } else {
            console.log('ERROR: WIDGET <', widgetName, '> NO ENCONTRADO');
          }
        });
      });
      this.reloadSubject.next(this.filters);
    });
    this.changeDetectorRef.detectChanges();
    this.loaded = true;
  }

  moveWidgetDown(columnIndex: number, widgetIndex: number) {
    console.log('down->', columnIndex, widgetIndex);
    let column: DashboardColumn = this.activeDashBoard.columns.find(
      (itemColumn: DashboardColumn) => itemColumn.columnNumber == columnIndex
    );
    column.components.splice(
      widgetIndex - 1,
      0,
      column.components.splice(widgetIndex, 1)[0]
    );
    this.loadComponents(this.activeDashBoard);
  }

  moveWidgetUp(columnIndex: number, widgetIndex: number) {
    // console.log('up->', index)
    // this.components.splice(index + 1, 0, this.components.splice(index, 1)[0]);
    // this.ngAfterContentInit();
    console.log('up->', columnIndex, widgetIndex);
    let column: DashboardColumn = this.activeDashBoard.columns.find(
      (columnFind: DashboardColumn) => columnFind.columnNumber == columnIndex
    );
    column.components.splice(
      widgetIndex + 1,
      0,
      column.components.splice(widgetIndex, 1)[0]
    );
    this.loadComponents(this.activeDashBoard);
  }

  getComponentByName(componentName: string): any {
    switch (componentName) {
      case AvailableWidgets.WIDGET:
        return widgetComponent;
      case AvailableWidgets.TABLE:
        return tableComponent;
      case AvailableWidgets.FAVOURITES:
        return favouritesComponent;
      case AvailableWidgets.CHART:
        return chartComponent;
      case AvailableWidgets.AUDITUSER:
        return auditUserComponent;
      case AvailableWidgets.TASKCOUNT:
        return taskCountComponent;
      case AvailableWidgets.SESSIONCOUNT:
        return sessionCountComponent;
      case AvailableWidgets.SYSTIME:
        return sysTimeComponent;
      case AvailableWidgets.PROCUREMENT_COMMITTEE_TASKS:
        return taskProcurementCommitteeComponent;
    }
  }

  getNumCols(): number {
    return this.cols;
  }

  // TODO ¿Se usa?
  setActiveDashBoard(db: DashBoard) {
    if (this.activeDashBoard.id !== db.id) {
      this.loadComponents(db);
    }
  }

  // TODO ¿se usa?
  getIdActiveDashBoard(): string {
    return this.activeDashBoard.id;
  }
  // TODO ¿se usa?
  getClassCol(): string {
    return 'col-' + 12 / this.getNumCols();
  }

  showMessage() {
    this.uiService.showENSAlertMessage();
  }

  getWidgetById(id: string): WidgetDefinition {
    if (this.availableWidgets) {
      return this.availableWidgets.filter((x) => x.id === id)[0];
    } else {
      return undefined;
    }
  }

  protected getAvailableWidgets(): Observable<Array<WidgetDefinition>> {
    let availableWidgetsProducto = this.plycaService
      .getJSON('dashboardDef/widgetList')
      .pipe(
        catchError((error: any) => {
          console.log(
            'Error al cargar los widgets disponibles de producto',
            error
          );
          return of(undefined);
        })
      );
    let availableWidgetsAdap = this.plycaService
      .getJSON('adapt/dashboardDef/widgetList')
      .pipe(
        catchError((error: any) => {
          console.log(
            'Error al cargar los widgets disponibles de la adaptacion',
            error
          );
          return of(undefined);
        })
      );

    return forkJoin(availableWidgetsProducto, availableWidgetsAdap).pipe(
      map((result: WidgetDefinition[]) => {
        let availableWidgets;
        if (result[1]) {
          availableWidgets = lodash.mergeWith(
            result[0],
            result[1],
            (oldValue, newValue) => newValue
          );
        } else {
          availableWidgets = result[0];
        }

        return availableWidgets;
      }),
      finalize(() => {
        // this.helpService.showContextHelp(this.tagsParent);
        console.log('Creado');
      })
    );
  }

  protected getDashBoardDefs(): Observable<Array<DashBoard>> {
    let dashBoardProducto = this.plycaService
      .getJSON('dashboardDef/dashBoardDefs')
      .pipe(
        catchError((error: any) => {
          console.log(
            'Error al cargar los cuadros de mando disponibles de producto',
            error
          );
          return of(undefined);
        })
      );
    let dashBoardAdap = this.plycaService
      .getJSON('adapt/dashboardDef/dashBoardDefs')
      .pipe(
        catchError((error: any) => {
          console.log(
            'Error al cargar los cuadros de mando disponibles de la adaptacion',
            error
          );
          return of(undefined);
        })
      );

    return forkJoin(dashBoardProducto, dashBoardAdap).pipe(
      map((result: DashBoard[]) => {
        let dashBoardDefs;
        if (result[1]) {
          dashBoardDefs = lodash.mergeWith(
            result[0],
            result[1],
            (oldValue, newValue) => newValue
          );
        } else {
          dashBoardDefs = result[0];
        }

        return dashBoardDefs;
      }),
      finalize(() => {
        // this.helpService.showContextHelp(this.tagsParent);
        console.log('Creado');
      })
    );
  }
  protected createFormConfig(db: DashBoard) {
    let _formConfig = new FormConfig(undefined, undefined, this.filters);
    let actions = new Array<FormAction<any>>();
    let searchAction: FilterFormAction = new FilterFormAction();
    searchAction.executeFormAction = this.actionWidget.bind(this);
    actions.push(searchAction);
    _formConfig.actions = actions;
    _formConfig.interfaceSetting = db.filters
    this.formConfig = _formConfig;
  }

  actionWidget(): Observable<any> {
    this.reloadSubject.next(this.filters);
    return EMPTY;
  }
}

class FilterFormAction implements FormAction<any> {
  visibility = true;
  actionId = 'search';
  buttonTextKey = 'General.reload';
  buttonClass = 'btn btn-primary';
  imageClass = 'fas fa-search';
  closeOnSuccess = false;
  executeFormAction: any;
}
